/**
 * Blackjack Multiplayer - Main Component
 * Orchestrates between lobby and table views
 */

import { useState } from 'react'
import { TableLobby } from './components/TableLobby'
import { MultiplayerTable } from './components/MultiplayerTable'

interface BlackjackMultiplayerProps {
  onPlaySolo: () => void
  onExit: () => void
}

export function BlackjackMultiplayer({ onPlaySolo, onExit: _onExit }: BlackjackMultiplayerProps) {
  const [activeTableId, setActiveTableId] = useState<string | null>(null)

  if (activeTableId) {
    return (
      <MultiplayerTable
        tableId={activeTableId}
        onLeave={() => setActiveTableId(null)}
      />
    )
  }

  return (
    <TableLobby
      onPlaySolo={onPlaySolo}
      onJoinTable={setActiveTableId}
    />
  )
}

export default BlackjackMultiplayer
